import { render, staticRenderFns } from "./stock-order.vue?vue&type=template&id=0c113396&scoped=true"
import script from "./stock-order.vue?vue&type=script&lang=js"
export * from "./stock-order.vue?vue&type=script&lang=js"
import style0 from "./stock-order.vue?vue&type=style&index=0&id=0c113396&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c113396",
  null
  
)

export default component.exports